import { Box, Button, CircularProgress, Container, Modal, Stack } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getMetaData, postConfiguration, updateConfiguration } from '../../services/uiConfigService';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import DefaultHeading from '../heading/DefaultHeading';
import { configurationAttributeType } from '../../types';
import { openPopup } from '../../stateManagement/actions/popupActions';
import { defaultParamsList } from './eventConfigRegistry';
import DefaultParamList from './DefaultParamList';

function DefaultParamsModal({ open, handleModalClose, }: {
    open: boolean,
    handleModalClose: () => void,
}) {
    const config_name = 'analytics_config';
    const [defaultParams, setDefaultParams] = useState<any>({});
    const [loading, setLoading] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const updateDefaultParamsData = (type: string, id: string, newData: any) => {
        if (defaultParams[type]) {
            setDefaultParams((pre: any) => ({
                ...pre, [type]: {
                    ...pre[type],
                    [id]: {
                        ...pre[type][id],
                        ...newData
                    }
                }
            }))
        }
    }

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, id: string, type: string) => {
        const status = (e.target.checked) ? "active" : "inactive";
        updateDefaultParamsData(type, id, { ...defaultParams[id], status: status });
    }

    const handleParamNameChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string, type: string) => {
        updateDefaultParamsData(type, id, { ...defaultParams[id], name: e.target.value })
    }


    const validateData = (data: any): string | null => {
        const types = Object.keys(data);
        for (let i = 0; i < types.length; i++) {
            const typesData: any = data[types[i]];
            const keys = Object.keys(typesData);
            for (let i = 0; i < keys.length; i++) {
                if (typesData[keys[i]]?.name?.trim() === "") {
                    return `key(s) name cannot be empty`;
                }
            }
        }
        return null;
    }


    async function saveConfiguration(): Promise<void> {
        setIsSaving(true);
        try {

            const validationResults = validateData(defaultParams);

            if (!validationResults || validationResults === "") {
                let response = await getMetaData("clientconfig", config_name);
                let newConfigData = [{
                    name: "defaultParams",
                    type: "list",
                    value: [defaultParams],
                    description: "list of default params",
                    possibleVals: [],
                    docUrl: "",
                }]
                let result = null
                if (!response) {
                    result = await postConfiguration(config_name, newConfigData as configurationAttributeType<any>[])
                } else {
                    const indexOfDefaultParam = response.findIndex((item: { name: string }) => item.name === "defaultParams");
                    if (indexOfDefaultParam === -1) {
                        newConfigData = [...newConfigData, ...response];
                    } else {
                        response[indexOfDefaultParam] = newConfigData[0];
                        newConfigData = [...response];
                    }
                    result = await updateConfiguration(config_name, newConfigData as configurationAttributeType<any>[])
                }

                if (result.data?.status === "Failure") {
                    throw new Error("")
                } else {
                    openPopup('Success', `Data saved`)
                }
            } else {
                openPopup("Error", validationResults)
            }
        } catch (error) {
            console.error(error)
            openPopup('Error', "An error occurred while saving data.")
        } finally {
            setIsSaving(false);
        }
    }

    async function getDefaultParams(): Promise<void> {
        setLoading(true)
        try {
            const response = await getMetaData("clientconfig", config_name);
            let defaultParamsData = deepClone(defaultParamsList);
            if (response) {
                const defaultParams = response.find((item: any) => item.name === "defaultParams");
                if (defaultParams) {
                    defaultParamsData = deepClone(defaultParams.value[0]);
                }
            }
            setDefaultParams(defaultParamsData);
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (open) getDefaultParams();
    }, [open])


    return (
        <Modal open={open} onClose={handleModalClose} keepMounted>
            <Box sx={{ bgcolor: 'background.paper' }} className="default-params-modal-box" justifyContent={'center'} >
                <DefaultHeading heading='Default Params'>
                    <Button variant="contained" sx={{ backgroundColor: "#23c6b0" }} onClick={saveConfiguration} disabled={isSaving}
                    >
                        {isSaving ? 'Saving...' : 'Save'}
                    </Button>
                </DefaultHeading>
                {
                    loading ? <Container className='default-parmas-loading-wrapper'>
                        <CircularProgress size={40} />
                    </Container> :
                        <div className='default-params-lists-wrapper'>
                            <DefaultParamList
                                heading="Firebase"
                                type="firebase"
                                defaultParams={defaultParams["firebase"]}
                                handleCheckboxChange={handleCheckboxChange}
                                handleParamNameChange={handleParamNameChange}
                                />
                            <DefaultParamList
                                heading="Moengage"
                                type="moengage"
                                defaultParams={defaultParams["moengage"]}
                                handleCheckboxChange={handleCheckboxChange}
                                handleParamNameChange={handleParamNameChange}
                                />
                            <DefaultParamList
                                heading="Database"
                                type="database"
                                defaultParams={defaultParams["database"]}
                                handleCheckboxChange={handleCheckboxChange}
                                handleParamNameChange={handleParamNameChange}
                                />
                            </div>
                }
            </Box>
        </Modal >
    )
}

export default DefaultParamsModal